// React Router v6 Migration Helpers
import { useNavigate, useLocation, useParams, Location } from 'react-router-dom'
import { useMemo } from 'react'

type HistoryState = {
  [key: string]: unknown
}

type History = {
  push: (path: string, state?: HistoryState) => void
  replace: (path: string, state?: HistoryState) => void
  go: (n: number) => void
  goBack: () => void
  goForward: () => void
  location: Location
}

type RouteMatch = {
  params: Record<string, string | undefined>
  path: string
  url: string
}

// Polyfill for useHistory (v5) -> useNavigate (v6)
export const useHistory = (): History => {
  const navigate = useNavigate()
  const location = useLocation()

  return useMemo(
    () => ({
      push: (path: string, state?: HistoryState) => navigate(path, { state }),
      replace: (path: string, state?: HistoryState) => navigate(path, { replace: true, state }),
      go: (n: number) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location,
    }),
    [navigate, location]
  )
}

// Polyfill for useRouteMatch (v5) -> useParams + useLocation (v6)
export const useRouteMatch = (): RouteMatch => {
  const params = useParams()
  const location = useLocation()

  return useMemo(
    () => ({
      params,
      path: location.pathname,
      url: location.pathname,
    }),
    [params, location]
  )
}
